import React, { Component } from 'react';

class Footer extends Component {
  constructor() {
    super();
    this.state = {

    };
  }

  componentWillMount(){
  }

  render() {
    return (
      this.props.tipo==='false'?
        (<h5 className="bg-primary text-light" align="center"><br/>Sistema de Organização de Históricos<br/><br/></h5>):
        (<h6 className="bg-primary text-light" align="center"><br/>&#9400;&nbsp;Desenvolvido por Luciano Alves<br/><br/></h6>)
    );
  }
}

export default Footer;
